<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'
    import { altLanguages, lg, setLg } from 'hydria/services/language'
    import { revalidating, session, signedIn, user } from 'hydria/services/session'
    import { onDestroy } from 'svelte'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    interface Props {
        signedoutSite?: boolean
        menuToggle: () => void
    }

    let { signedoutSite = false, menuToggle = () => {} }: Props = $props()

    let codeHasChanged: boolean = $state(false)
    unsubs.push(
        session.modHashesChanged.subscribe((v) => {
            codeHasChanged = v
        }),
    )

    export async function signout() {
        await session.signout()
    }
</script>

<style>
    #topbar.code-changed {
        background-color: var(--bs-danger);
    }
</style>

<div id="topbar" class:code-changed={codeHasChanged}>
    {#if !signedoutSite}
        <div
            class="menu-toggle"
            tabindex="0"
            role="button"
            onkeypress={(e) => {
                if ([' ', 'Enter'].includes(e.key)) menuToggle()
            }}
            onclick={() => {
                menuToggle()
            }}
        >
            <span><Icon inline icon="fa:bars" /></span>
        </div>
    {/if}
    <div class="subject">
        {#if codeHasChanged}
            <Icon inline icon="mdi:warning" />
            <span>Le code a changé, s.v.p. recharger la page.</span>
        {:else}
            <Icon inline icon="fa:user" />
            <span>Administration – WebDomaine</span>
        {/if}
    </div>
    {#each $altLanguages as altLg (altLg.lg)}
        <a
            href="/"
            onclick={(e) => {
                e.preventDefault()
                setLg(altLg.lg)
            }}><span>{altLg.text}</span></a
        >
    {/each}
    {#if !signedoutSite}
        {#if $signedIn && $user && $user.name != null}
            <div class:revalidating={$revalidating}><span>{$user.name}</span></div>
        {/if}
        <a
            href="/{$lg}/"
            onclick={(e) => {
                e.preventDefault()
                signout()
            }}
        >
            <Icon inline icon="fa:sign-out" />
            <span>{$_('Sign out')}</span>
        </a>
    {/if}
</div>
